// Service layer for the Today aggregate endpoint.
//
// Backend: GET /api/secure/me/today — aggregate of medicines, meals, activities,
// vitals, mood, goals, sessions, unread, dues, packs (each section nullable).
// Mock: src/patient/services/mockApi/todayApi.js produces a profile-aware
// rich payload for F2 demos.

import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/todayApi'
import { patientGet } from './patientApi'

const PATH = '/api/secure/me/today'

export async function getToday(profile) {
  if (shouldUseMocks()) return mock.getToday(profile)
  // Pass profile.id explicitly — patientApi prefers this over localStorage.
  // The patient-portal backend interceptor REQUIRES the patientId
  // header on /me/today (one user can have multiple PatientInfo records,
  // one per brand — server can't infer which to use without it).
  const res = await patientGet(PATH, {
    requirePatientContext: true,
    profileId: profile?.id,
  })
  return res?.data || null
}

// Quick-action passthroughs (mock-only for now; real impl uses dedicated
// per-resource endpoints — POST /me/medicines/:id/intake, POST /me/diet/log,
// etc. — which the relevant per-resource service modules expose.)

export async function markMedicineTaken(profile, key) {
  if (shouldUseMocks()) return mock.quickMutate(profile, key, true)
  // Real-backend path: see medicinesService.markIntake when wired.
  return null
}

export async function logMeal(profile, mealKey, summary) {
  if (shouldUseMocks()) return mock.quickMutate(profile, mealKey, summary || true)
  return null
}

export async function completeActivity(profile, key) {
  if (shouldUseMocks()) return mock.quickMutate(profile, key, true)
  return null
}

export async function logVital(profile, key) {
  if (shouldUseMocks()) return mock.quickMutate(profile, key, true)
  return null
}

// Mood check-in moved to a dedicated service — this passthrough preserves
// the useToday() callback shape so the Today page doesn't need to know the
// difference. payload: { moodCode, note?, factors? }.
export { recordCheckIn as recordMood } from './moodService'
